import React from "react";
import { Select, TextField } from "../inputs";
import GenericFields from "./GenericFields";
import SignatureSection from "./SignatureSection";

const ChangeNameFields = () => {
  return (
    <>
      <p>Please provide your updated legal name in the fields below.</p>

      <div className="form-row">
        <div className="form-item">
          <TextField label="First Name" name="data[new_first_name]" required />
        </div>

        <div className="form-item">
          <TextField label="Last Name" name="data[new_last_name]" required />
        </div>
      </div>

      <p>
        After completing this form, you will also be required to submit proof of
        your legal name change to the Office of the Registrar at
        registrar@aimseducation.edu. If you are trying to change your preferred
        name, please visit{" "}
        <a href="https://aimseducation.edu/statement-support-preferred-names">
          https://aimseducation.edu/statement-support-preferred-names
        </a>
        .
      </p>
    </>
  );
};

const ChangePhoneFields = () => {
  return (
    <>
      <p>Please provide your updated phone number below.</p>

      <div className="form-row">
        <div className="form-item">
          <TextField
            label="Old Phone Number"
            name="data[old_phone_number]"
            required
          />
        </div>

        <div className="form-item">
          <TextField
            label="New Phone Number"
            name="data[new_phone_number]"
            required
          />
        </div>
      </div>
    </>
  );
};

const ChangeEmailFields = () => {
  return (
    <>
      <p>Please provide your updated email address below.</p>

      <div className="form-row">
        <div className="form-item">
          <TextField
            type="email"
            label="Old Email Address"
            name="data[old_email]"
            required
          />
        </div>

        <div className="form-item">
          <TextField
            type="email"
            label="New Email Address"
            name="data[new_email]"
            required
          />
        </div>
      </div>
    </>
  );
};

const ChangeAddressFields = () => {
  return (
    <>
      <p>Please provide your updated address below.</p>

      <TextField label="New Address" name="data[new_address]" required />

      <div className="form-row">
        <div className="form-item">
          <TextField label="New City" name="data[new_city]" required />
        </div>

        <div className="form-item">
          <TextField label="New State" name="data[new_state]" required />
        </div>

        <div className="form-item">
          <TextField label="New ZIP" name="data[new_zip]" required />
        </div>
      </div>
    </>
  );
};

export default function ChangeOfPersonalInformation() {
  const [requestedChange, setRequestedChange] = React.useState(undefined);

  const handleRequestedChange = (e) => setRequestedChange(e.target.value);

  return (
    <form
      method="POST"
      action="/student-request/change-of-personal-information"
      onSubmit={() => {
        setSubmitting(true);
      }}
    >
      <GenericFields />

      <Select
        label="Which personal information are you changing?"
        options={[
          ["name", "Name"],
          ["phone", "Phone"],
          ["email", "Email"],
          ["address", "Address"],
        ]}
        value={requestedChange}
        onChange={handleRequestedChange}
      />

      <div>
        {requestedChange === "name" && <ChangeNameFields />}
        {requestedChange === "phone" && <ChangePhoneFields />}
        {requestedChange === "email" && <ChangeEmailFields />}
        {requestedChange === "address" && <ChangeAddressFields />}
      </div>

      {requestedChange && (
        <>
          <SignatureSection />
        </>
      )}
    </form>
  );
}
